import { render } from "./Dropdown3.vue?vue&type=template&id=2503b747&ts=true"
import script from "./Dropdown3.vue?vue&type=script&lang=ts"
export * from "./Dropdown3.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__